export const themePresets = {
  'gaming-neon': {
    key: 'gaming-neon',
    label: 'Gaming Neon',
    variables: {
      '--site-bg-base': '#020617',
      '--site-bg-elevated': '#0f172a',
      '--site-bg-surface': 'rgba(15, 23, 42, 0.78)',
      '--site-text-primary': '#f8fafc',
      '--site-text-secondary': '#94a3b8',
      '--site-accent-primary': '#06b6d4',
      '--site-accent-primary-strong': '#0891b2',
      '--site-accent-secondary': '#8b5cf6',
      '--site-success': '#22c55e',
      '--site-error': '#f87171',
      '--site-overlay-strong': 'rgba(0, 0, 0, 0.72)',
      '--site-border-soft': 'rgba(34, 211, 238, 0.18)',
      '--site-shadow-glow': 'rgba(6, 182, 212, 0.28)',
      '--site-gradient-start': '#020617',
      '--site-gradient-mid': '#0f172a',
      '--site-gradient-end': '#111827',
      '--site-font-body': 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      '--site-font-display': 'Rajdhani, Inter, sans-serif',
    },
  },
  'studio-pro': {
    key: 'studio-pro',
    label: 'Studio Pro',
    variables: {
      '--site-bg-base': '#f5f7fb',
      '--site-bg-elevated': '#ffffff',
      '--site-bg-surface': 'rgba(255, 255, 255, 0.9)',
      '--site-text-primary': '#0f172a',
      '--site-text-secondary': '#475569',
      '--site-accent-primary': '#2563eb',
      '--site-accent-primary-strong': '#1d4ed8',
      '--site-accent-secondary': '#0f766e',
      '--site-success': '#16a34a',
      '--site-error': '#dc2626',
      '--site-overlay-strong': 'rgba(15, 23, 42, 0.62)',
      '--site-border-soft': 'rgba(37, 99, 235, 0.12)',
      '--site-shadow-glow': 'rgba(37, 99, 235, 0.16)',
      '--site-gradient-start': '#f8fafc',
      '--site-gradient-mid': '#eef2ff',
      '--site-gradient-end': '#e2e8f0',
      '--site-font-body': 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      '--site-font-display': 'Inter, "Segoe UI", sans-serif',
    },
  },
  'sunset-arcade': {
    key: 'sunset-arcade',
    label: 'Sunset Arcade',
    variables: {
      '--site-bg-base': '#1a1027',
      '--site-bg-elevated': '#251538',
      '--site-bg-surface': 'rgba(37, 21, 56, 0.84)',
      '--site-text-primary': '#fff7ed',
      '--site-text-secondary': '#fbcfe8',
      '--site-accent-primary': '#fb7185',
      '--site-accent-primary-strong': '#e11d48',
      '--site-accent-secondary': '#f59e0b',
      '--site-success': '#4ade80',
      '--site-error': '#fb7185',
      '--site-overlay-strong': 'rgba(20, 11, 31, 0.72)',
      '--site-border-soft': 'rgba(251, 113, 133, 0.2)',
      '--site-shadow-glow': 'rgba(245, 158, 11, 0.18)',
      '--site-gradient-start': '#140b1f',
      '--site-gradient-mid': '#331a4d',
      '--site-gradient-end': '#4f1d36',
      '--site-font-body': 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      '--site-font-display': 'Rajdhani, Inter, sans-serif',
    },
  },
  'noir-terminal': {
    key: 'noir-terminal',
    label: 'Noir Terminal',
    variables: {
      '--site-bg-base': '#050816',
      '--site-bg-elevated': '#0d1324',
      '--site-bg-surface': 'rgba(13, 19, 36, 0.86)',
      '--site-text-primary': '#e2f7f1',
      '--site-text-secondary': '#89bcb2',
      '--site-accent-primary': '#2dd4bf',
      '--site-accent-primary-strong': '#14b8a6',
      '--site-accent-secondary': '#22c55e',
      '--site-success': '#22c55e',
      '--site-error': '#f43f5e',
      '--site-overlay-strong': 'rgba(3, 7, 18, 0.76)',
      '--site-border-soft': 'rgba(45, 212, 191, 0.16)',
      '--site-shadow-glow': 'rgba(45, 212, 191, 0.18)',
      '--site-gradient-start': '#030712',
      '--site-gradient-mid': '#08111e',
      '--site-gradient-end': '#11201f',
      '--site-font-body': '"Fira Code", "SFMono-Regular", Menlo, monospace',
      '--site-font-display': '"Fira Code", "SFMono-Regular", Menlo, monospace',
    },
  },
  'ember-studio': {
    key: 'ember-studio',
    label: 'Ember Studio',
    variables: {
      '--site-bg-base': '#fff8f2',
      '--site-bg-elevated': '#fff1e8',
      '--site-bg-surface': 'rgba(255, 241, 232, 0.84)',
      '--site-text-primary': '#2b1308',
      '--site-text-secondary': '#7c4a2c',
      '--site-accent-primary': '#ea580c',
      '--site-accent-primary-strong': '#c2410c',
      '--site-accent-secondary': '#7c3aed',
      '--site-success': '#15803d',
      '--site-error': '#dc2626',
      '--site-overlay-strong': 'rgba(43, 19, 8, 0.54)',
      '--site-border-soft': 'rgba(234, 88, 12, 0.12)',
      '--site-shadow-glow': 'rgba(234, 88, 12, 0.12)',
      '--site-gradient-start': '#fffaf5',
      '--site-gradient-mid': '#ffedd5',
      '--site-gradient-end': '#fde68a',
      '--site-font-body': 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      '--site-font-display': 'Rajdhani, Inter, sans-serif',
    },
  },
};

export const defaultThemeKey = 'gaming-neon';

export const getThemePreset = (themeKey) => themePresets[themeKey] || themePresets[defaultThemeKey];
